var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",class:{
    [_vm.color]: true,
    pill: _vm.isPill,
    'tag--wide': _vm.isWide,
    'tag--fill': _vm.fill
  }},[_vm._t("default"),_vm._v(" "),(_vm.withCloseButton)?_c('span',{staticClass:"tag_close",attrs:{"aria-label":"Close"},on:{"click":_vm.removeTag}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }